import React, { useEffect, useState } from "react";
import {
  Paper,
  Typography,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Divider,
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@material-ui/core";

import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import TuneIcon from "@material-ui/icons/Tune";

import { withTitle, withAuth } from "../../HoC";

import { socketManager } from "../../services/socketService/socketManager";
import { compose } from "redux";
import { connect } from "react-redux";
import { generateUniqueId } from "../../utils/uuid4";
import { Button } from "../../Components/button";
import { SOCKET_ACTIONS } from "../../services/socketService/actions";
import { Footer } from "../../Components/Footer/Footer";
import { Warning } from "../../Components/Warning/Warning";
import { Settings } from "../../Components/Settings/Settings";
import { getControllerColors } from "../../utils/constants";
import { translate } from "../../translations/translate";

import StyledController from "./Controller.style";

const translateController = (key: string) => translate(`controller.${key}`);

export const ControllerPage = (props) => {

  const {
    devices = [],
    socketReducer,
  } = props;

  const {
    isConnected,
    counter = 0,
    capacity,
    isInTimeout = false,
    maxReached = false,
    queue = [],
  } = socketReducer;
  const selectedDevice = devices.find((e) => e.uuid === props.match.params.deviceId);

  if (!selectedDevice) {
    props.history.push("/admin");
  }

  const {
    name = "",
    id: deviceId,
    bookingActivated = 0,
  } = selectedDevice || {};

  const randomId = generateUniqueId();

  useEffect(() => {
    socketManager.init({ deviceId, uid: randomId});
    return () => socketManager.close();
  }, []);

  const [ settingsOpen, setSettings ] = useState(false);

  return (<StyledController>
    <Grid direction="column" justifyContent="center" alignItems="center" container>
      <Grid className="grid-item" xs={12} sm={8} md={6}>
        <Card style={{ opacity: maxReached ? 1 : 0, transition: "opacity .7s ease-in" }} >
          <CardContent>
            <div className="warning">
              <Warning width={40} height={40} />
              <h3> {translate("max-capacity")} </h3>
              <Warning width={40} height={40} />
            </div>
          </CardContent>
        </Card>
      </Grid>
      <Grid className="grid-item" xs={12} sm={8} md={6}>
        <Card className="card">
          <CardHeader title={name}/>
          <CardContent>
          <div className="data-container">
            <Paper elevation={2} className="coda">
              <Typography variant="body1" color="primary" > {translate("accesses")}
                <Typography variant="body2" display="inline"> {counter} / {capacity} </Typography>
              </Typography>
            </Paper>
            {bookingActivated ? (
              <Paper elevation={4} className="coda">
                <p> {translate("in-queue")}  </p>
                <p> {queue.map(({ orderNumber, priority }, i) => <span style={{ color: getControllerColors(priority) }} className="queue" key={i}> {orderNumber} </span>)} </p>
              </Paper>
            ) : null}
          </div>
          </CardContent>
          <Divider />
          <CardActions className="card-actions">
            <Button
              label={translateController("client-enter")}
              onClick={() => socketManager.send(SOCKET_ACTIONS.CLIENT_ENTER)}
              startIcon={<AddIcon />}
            />
            <Button
              label={translateController("client-exit")}
              onClick={() => socketManager.send(SOCKET_ACTIONS.CLIENT_EXIT)}
              startIcon={<RemoveIcon />}
            />
          </CardActions>
        </Card>
      </Grid>
      <Grid className="grid-item" xs={12} sm={8} md={6}>
        <Accordion className="accordion">
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            style={{ flexDirection: "row" }}
          >
            <div className="summary">
              <TuneIcon />
              <Typography variant="h5" > Impostazioni </Typography>
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <Button
              label={translateController(isInTimeout ? "in-service" : "out-of-service")}
              onClick={() =>
                socketManager.send(isInTimeout ? SOCKET_ACTIONS.EXIT_TIMEOUT : SOCKET_ACTIONS.ENTER_TIMEOUT)}
            />
            <Button
              label={translate("options")}
              onClick={() => setSettings(true)}
            />
          </AccordionDetails>
        </Accordion>
      </Grid>
    </Grid>
    {settingsOpen ?
      (<Settings
        resetCount={() => socketManager.send(SOCKET_ACTIONS.RESET_SESSION)}
        onClose={() => setSettings(false)}
      />) : null}
    <Footer isConnected={isConnected} />
  </StyledController>);
};

const mapStateToProps = (state: any) => ({
  controllerReducer: state.controllerReducer,
  devices: state.adminReducer.devices,
  socketReducer: state.socketReducer,
});

export default compose(
  withTitle(translate("controller")),
  withAuth(0),
  connect(mapStateToProps),
)(ControllerPage);
